import React from 'react';
import { Input } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import { DateRangePicker } from 'react-date-range';
import dayjs from 'dayjs';
import './DateRangeFilter.css';
const staticRanges = [
  {
    label: 'Today',
    range: () => ({
      startDate: dayjs().startOf('day').toDate(),
      endDate: dayjs().endOf('day').toDate()
    }),
    isSelected(range) {
      const today = dayjs().startOf('day');
      return (
        dayjs(range.startDate).isSame(today, 'day') &&
        dayjs(range.endDate).isSame(today, 'day')
      );
    }
  },
  {
    label: 'Yesterday',
    range: () => ({
      startDate: dayjs().subtract(1, 'day').startOf('day').toDate(),
      endDate: dayjs().subtract(1, 'day').endOf('day').toDate()
    }),
    isSelected(range) {
      const yesterday = dayjs().subtract(1, 'day').startOf('day');
      return (
        dayjs(range.startDate).isSame(yesterday, 'day') &&
        dayjs(range.endDate).isSame(yesterday, 'day')
      );
    }
  },
  {
    label: 'This Week',
    range: () => ({
      startDate: dayjs().startOf('week').toDate(),
      endDate: dayjs().endOf('week').toDate()
    }),
    isSelected(range) {
      const startOfWeek = dayjs().startOf('week');
      const endOfWeek = dayjs().endOf('week');
      return (
        dayjs(range.startDate).isSame(startOfWeek, 'day') &&
        dayjs(range.endDate).isSame(endOfWeek, 'day')
      );
    }
  },
  {
    label: 'Last Week',
    range: () => ({
      startDate: dayjs().subtract(1, 'week').startOf('week').toDate(),
      endDate: dayjs().subtract(1, 'week').endOf('week').toDate()
    }),
    isSelected(range) {
      const startOfLastWeek = dayjs().subtract(1, 'week').startOf('week');
      const endOfLastWeek = dayjs().subtract(1, 'week').endOf('week');
      return (
        dayjs(range.startDate).isSame(startOfLastWeek, 'day') &&
        dayjs(range.endDate).isSame(endOfLastWeek, 'day')
      );
    }
  },
  {
    label: 'This Month',
    range: () => ({
      startDate: dayjs().startOf('month').toDate(),
      endDate: dayjs().endOf('month').toDate()
    }),
    isSelected(range) {
      const startOfMonth = dayjs().startOf('month');
      const endOfMonth = dayjs().endOf('month');
      return (
        dayjs(range.startDate).isSame(startOfMonth, 'day') &&
        dayjs(range.endDate).isSame(endOfMonth, 'day')
      );
    }
  },
  {
    label: 'Last Month',
    range: () => ({
      startDate: dayjs().subtract(1, 'month').startOf('month').toDate(),
      endDate: dayjs().subtract(1, 'month').endOf('month').toDate()
    }),
    isSelected(range) {
      const startOfLastMonth = dayjs().subtract(1, 'month').startOf('month');
      const endOfLastMonth = dayjs().subtract(1, 'month').endOf('month');
      return (
        dayjs(range.startDate).isSame(startOfLastMonth, 'day') &&
        dayjs(range.endDate).isSame(endOfLastMonth, 'day')
      );
    }
  }
];

const DateRangeFilter = ({
  selectedRange,
  togglePicker,
  pickerOpen,
  handleDateChange,
  pickerRef,
  label = "Date Range",
  showLabel = true,
  containerStyle = {},
  inputStyle = {},
  dropdownStyle = {},
  disabledDay = () => false
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '6px',
      minWidth: '190px',
      ...containerStyle
    }}>
      {showLabel && (
        <div style={{ 
          fontSize: '12px', 
          fontWeight: '600', 
          color: '#4b5563',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          justifyContent: 'flex-start'
        }}>
          <CalendarOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
          <span>{label}</span>
        </div>
      )}

      <div ref={pickerRef} style={{ position: 'relative' }}>
        <Input
          className="date-range-input"
          value={`${dayjs(selectedRange[0].startDate).format('MMM DD, YYYY')} - ${dayjs(selectedRange[0].endDate).format('MMM DD, YYYY')}`}
          onClick={togglePicker}
          readOnly
          prefix={<CalendarOutlined style={{ color: '#3b82f6' }} />}
          size="small"
          style={{ 
            fontSize: '12px',
            color: '#000',
            cursor: 'pointer',
            backgroundColor: '#fff',
            border: '1px solid #e2e8f0',
            borderRadius: '4px',
            minHeight: '24px',
            lineHeight: '24px',
            ...inputStyle
          }}
        />
        {pickerOpen && (
          <div 
            className="date-picker-dropdown" 
            style={{
              position: 'absolute',
              zIndex: 1000,
              top: '100%',
              right: '0',
              left: 'auto',
              backgroundColor: 'white',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
              borderRadius: '8px',
              border: '1px solid #e2e8f0',
              ...dropdownStyle
            }}
          >
            <DateRangePicker
              ranges={selectedRange}
              onChange={handleDateChange}
              months={1}
              direction="horizontal"
              staticRanges={staticRanges}
              inputRanges={[]}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              preventSnapRefocus={true}
              disabledDay={disabledDay}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DateRangeFilter; 